module.exports = "pegasus/assets/graycircle-pinterest.gif";